import { downloadForumAttachment } from '../services/ForumService';

async function blobFromResponse(res) {
  const contentType = res.headers?.['content-type'] || '';
  if (contentType.includes('application/json')) {
    const text = await res.data.text();
    const json = JSON.parse(text);
    if (json.success === false) {
      throw new Error(json.message || 'Could not download file');
    }
  }
  return res.data;
}

export async function fetchForumAttachmentBlob(fileId) {
  const res = await downloadForumAttachment(fileId);
  return blobFromResponse(res);
}

export async function openForumAttachmentInNewTab(fileId) {
  const blob = await fetchForumAttachmentBlob(fileId);
  const objectUrl = URL.createObjectURL(blob);
  const w = window.open(objectUrl, '_blank', 'noopener,noreferrer');
  if (!w) {
    URL.revokeObjectURL(objectUrl);
  }
  setTimeout(() => URL.revokeObjectURL(objectUrl), 120000);
}

export async function downloadForumAttachmentFile(fileId, suggestedFileName) {
  const blob = await fetchForumAttachmentBlob(fileId);
  const objectUrl = URL.createObjectURL(blob);
  try {
    const a = document.createElement('a');
    a.href = objectUrl;
    a.download = suggestedFileName || 'download';
    a.rel = 'noopener';
    document.body.appendChild(a);
    a.click();
    a.remove();
  } finally {
    setTimeout(() => URL.revokeObjectURL(objectUrl), 60000);
  }
}
